<template>
  <b-button
    :class="`raised ${styleClasses}`"
    @click="$router.push(route)"
  >
    <badge v-if="displayBadge" :yOffset="badgeOffsetY" :xOffset="badgeOffsetX" :text="badgeText" />
    <font-awesome-icon v-if="icon" :icon="icon"/>
    {{ text }}
  </b-button>
</template>

<script>
import Badge from '@/components/utils/Badge';


export default {
  components: {
    Badge,
  },
  props: {
    route: {
      type: [Object, String],
      required: true,
    },
    displayBadge: Boolean,
    badgeOffsetX: {
      type: [String, Number],
      default: -20,
    },
    badgeOffsetY: {
      type: [String, Number],
      default: 15,
    },
    badgeText: [String, Number],
    icon: String,
    text: String,
    styleClasses: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/navigation/NavigationButton.vue